export default "__VITE_ASSET__jr54qAFy__"